import { render, staticRenderFns } from "./PackageGalleryManageAdd.vue?vue&type=template&id=6dc25c7a"
import script from "./PackageGalleryManageAdd.vue?vue&type=script&lang=js"
export * from "./PackageGalleryManageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports